import request from '@/utils/httpRequest'

export default class CostBudgetPreparationAnnualService {
    queryById (params) {
        return request({
            url: '/budget/costBudgetPreparation/annual/queryById',
            method: 'get',
            params: params
        })
    }

    subjectTypeList(params){
        return request({
            url: '/budget/costBudgetPreparation/subject/selectTypes',
            method: 'get',
            params: params
        })
    }
}